import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";

const StateList = (props: any) => {
  const { handleIsActive } = props
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Country",
      accessorKey: "parent.name",
      cell: NACell,
    },
    {
      header: "Total District",
      accessorKey: "total_state",
      cell: NACell,
    },
    {
      header: "Total Cities",
      accessorKey: "total_district",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      )
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={`${APIS.LOCATION}flat-location`}
      queryKey={"state"}
      columns={defaultColumns}
      params={{ level: 1 }}
      addNewPagePath={"/create-state"}
      tableName={"State"}
    />
  );
};

export default StateList;
